<button *ngIf="patient" mat-menu-item [cdkCopyToClipboard]="copyPatientID()">
  <mat-icon>tag</mat-icon>
  <span>Copy Patient ID</span>
</button>
